// material-ui
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import React from "react";
// project import
import { drawerWidth, drawerWidthMin, VARIANT } from "../../../config";
import {
  colorinColores,
  industriaColores,
  tersuaveColores,
  variants,
} from "../../../constants/variants";

const openedMixin = (theme: any) => ({
  width: drawerWidth,
  borderRight: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  background:
    variants.COLORIN === VARIANT
      ? colorinColores.main
      : variants.INDUSTRIA === VARIANT
      ? industriaColores.main
      : tersuaveColores.main,
  overflowX: "hidden",
  boxShadow: "none",
});

const closedMixin = (theme: any) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  background:
    variants.COLORIN === VARIANT
      ? colorinColores.main
      : variants.INDUSTRIA === VARIANT
      ? industriaColores.main
      : tersuaveColores.main,
  width: drawerWidthMin,
  borderRight: "none",
  boxShadow: theme.customShadows.z1,
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== "open",
  // @ts-ignore
})(({ theme, open }: any) => ({
  width: drawerWidth,
  flexShrink: 0,

  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default MiniDrawerStyled;
